import { useLoggerStore } from '@/store/logger/logger-store'
import type { LoggerEvent } from '@/types/logger.types'

import type { DisableAdOrder, Order, Topup } from '.'

type PurchaseAnalyticsOrder = Order | DisableAdOrder | Topup | null

export function useInGamePurchaseAnalytics() {
    const loggerStore = useLoggerStore()

    function logPurchaseEvent(
        eventName: LoggerEvent['eventName'],
        order: PurchaseAnalyticsOrder,
        amount = order?.amount,
    ) {
        return loggerStore.logEvent({
            event: 'custom_event',
            eventName,
            action: order?.type,
            amountInGameCurrency: amount,
            adPlacement: order?.type === 'disable-ad-order' ? order.placement : undefined,
            dimension1: order?.type,
            dimension2: amount?.toString(),
            dimension3: order?.type === 'order' ? order.description : undefined,
        })
    }

    function logNewSubscriptionAfterInGamePurchase(order: Order) {
        return loggerStore.logEvent({
            event: 'custom_event',
            eventName: 'new_subscription_after_in_game_purchase',
            dimension1: order.type,
            dimension2: order.amount.toString(),
        })
    }

    return { logNewSubscriptionAfterInGamePurchase, logPurchaseEvent }
}
